
//职位名称  职位级别
const columnList: Array<column> = [
    {
        prop: "role_name",
        label: "职位名称",
        width: 300,
    },
    {
        prop: "text",
        label: "职位级别",
        width: 300,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { column } from "@/assets/types/common";
import { Request } from "@/api/request";

export default defineComponent({
    name: "Jurisdiction",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["门店管理", "菜单管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            loading = ref(false),
            headClass = inject("headClass"),
            Route = useRoute(),
            Router = useRouter(),
            form = ref({
                parent_id: null,
                name: "",
                path: "",
                url: "",
                router_name: "",
                isshow: "0",
                redirect: "",
                components: "",
                weight: 1,
                type: 1,
            }),
            formRef = ref(null),
            id: any = null,
            menuList = ref([]),
			menuType: any = null,
            screenParameter: any = {
                admin_id: 0,
                page: currentPage.value,
                pagesize: pageSize.value,
            },
            getTableData = (): void => {
                id = Route.query.id;
                menuType = Route.query.type;
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Privilege/info",
                    data: {
                        id: Route.query.id
                    },
                }).then((res: any) => {
					console.log(res)
                    form.value = res?.content?.list || {};
                });
                Request.axiosInstance({
                    url: "adminapi/Privilege/menuList",
                    data: {
                        id: Route.query.id,
                        type: Route.query.type,
                    },
                }).then((res: any) => {
                    // form.value = res?.content?.list || {};
                    loading.value = false;
                });
            },
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let data: any = {
                                ...form.value,
                            },
                            url = "adminapi/Privilege/menuCreate";
                        if (Object.keys(Route.query).length > 0) {
                            data = {
                                ...data,
                                id,
                            };
                            url = "adminapi/Privilege/edit";
                        }

                        Request.axiosInstance({
                            url,
                            data,
                        }).then((res) => {
                            if (res.status == 202) {
                                Router.back();
                            }
                        });
                    }
                });
                // console.log(form.value);
            };

        onMounted(() => {
            if (Object.keys(Route.query).length > 0) {
                getTableData();
            }
            Request.axiosInstance({
                url: "adminapi/Privilege/superiorMenuList",
            }).then((res: any) => {
                menuList.value = res?.content?.list || [];
            });
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screenParameter,
            menuList,
            menuType,
            form,
            formRef,
            onSubmit
        };
    },
});
